import React, { useEffect } from 'react';

import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Link } from '@uhg-abyss/web/ui/Link';
export const ProcStatHelp = () => {
  var procStatJsonArr = [
    {
      section: 'Processing Statistics',
      fieldName: '',
      description:
        'Counts and metrics associated to a processed transaction set of a submission group.  Processing Statistics are specific to a processing date.  They are not cumulative.',
    },
    {
      section: '',
      fieldName: 'Customer Submission Group',
      description:
        'Counts and metrics associated to a processed transaction set of a submission group.  Processing Statistics are specific to a processing date.  They are not cumulative.',
    },
    {
      section: '',
      fieldName: 'Customer Number',
      description: 'Customer number processed',
    },
    {
      fieldName: 'Customer File Name',
      description: 'Name of the file processed',
    },
    {
      fieldName: 'Group ID',
      description:
        'Unique ID from a State File which the member belongs. [This field is used for CSP Processing]',
    },
    {
      fieldName: 'File Received Date',
      description:
        'Date the file was received (one file can contain one or many transaction sets)',
    },
    {
      fieldName: 'Group ID',
      description:
        'Unique ID from a State File which the member belongs. [This field is used for CSP Processing]',
    },
    {
      fieldName: 'File Received Date',
      description:
        'Date the file was received (one file can contain one or many transaction sets)',
    },
    {
      fieldName: 'Processing Date',
      description: 'Date the transaction set was processed.',
    },
    {
      fieldName: 'Profile Version',
      description:
        'Identifies the version of the Customer Profile used for processing',
    },
    {
      fieldName: 'File Identifier',
      description: 'Identifier assigned to the file.',
    },
    {
      fieldName: 'Processing Status',
    },
  ];
  var eligCorr = 'eligCorr';

  var procStatStatusJsonArr = [
    {
      statusCode: 'COMPLETE',
      explantion:
        'Transaction set has been processed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'COMPLETED WITH WARNINGS',
      explantion:
        'Transaction set has been processed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however, those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'COMPLETED WITH ERRORS',
      explantion:
        'Transaction set has been processed, but with errors detected on some records.  Those records not in error have been updated to the eligibility system, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'CMPL REPR ALL',
      explantion:
        'Transaction set has been reprocessed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'CMPL REPR ALL WITH WRN',
      explantion:
        'Transaction set has been reprocessed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'CMPL REPR ALL WITH ERR',
      explantion:
        'Tranaction set has been reprocessed, but with errors detected on some records.  Those records not in error have been updated to the Electronic Eligibility Management System, error records are pended in the Electronic Eligibility Management System process until resolved by the Electronic Eligibility Analyst assigned to the submission group or corrected by a new file submission from the customer.',
    },
    {
      statusCode: 'CMPL REPR PART',
      explantion:
        'Some transactions within this transaction set have been reprocessed and all records have been updated to the Electronic Eligibility Management System.',
    },
    {
      statusCode: 'CMPL REPR PART WITH WRN',
      explantion:
        'Some transactions within this transaction set have been reprocessed, but with low severity errors (warnings) detected on some records.  All records have been updated to the Electronic Eligibility Management System; however those records with warnings should be corrected by the customer via the next file submission to resolve inaccurate data.',
    },
    {
      statusCode: 'REPR THRESH XCD',
      explantion:
        'Thresholds violations were encountered during re-processing.  Entire transaction set is in error on the Electronic Eligibility Management System until researched and corrected by the Electronic Eligibility Analyst assigned to the submission group.',
    },
  ];
  var remContentJsonArr = [
    {
      section: 'Record Counts',
      fieldName: '',
      description:
        'The Record Counts contain all transactions that were processed by the Electronic Eligibility Management System',
    },
    {
      fieldName: 'Subscribers on File',
      description:
        'Total number of subscribers on the file processed on the selected date.',
    },
    {
      section: '',
      fieldName: 'Dependents on File',
      description:
        'Total number of dependents on the file processed on selected date.',
    },
    {
      fieldName: 'Customer File Name',
      description: 'Name of the file processed',
    },
    {
      fieldName: 'Total Records on File',
      description:
        'Total number of records on the file processed on selected date',
    },
    {
      fieldName: 'Subscriber Auto-Cancels',
      description:
        'Total number of subscriber auto-cancels processed on the selected date.',
    },
    {
      fieldName:
        'Subscriber Auto-Cancels and Transactions Built from Eligibility System',
      description:
        'Total number of subscribers auto-canceled and subscribers built and processed from the Eligibility System on the selected date.',
    },
    {
      fieldName: 'Dependent Auto-Cancels',
      description:
        'Total number of dependent auto-cancels processed on the selected date.',
    },
    {
      fieldName:
        'Dependent Auto-Cancels and Transactions Built from Eligibility System',
      description:
        'Total number of dependents auto-canceled and dependents built and processed from the Eligibility System on the selected date.',
    },
    {
      fieldName: 'Total Auto-Cancels',
      description:
        'Total number of auto-cancels processed on the selected date.',
    },
    {
      fieldName:
        'Total Auto-Cancels and Transactions Built from Eligibility System',
      description:
        'Total number of transactions auto-canceled and built and processed from the Eligibility System on the selected date.',
    },
    {
      fieldName: 'Total Transactions',
      description: 'Total number of records processed on the selected date.',
    },
    {
      fieldName:
        'Total Auto-Cancels and Transactions Built from Eligibility System',
      description:
        'Total number of transactions auto-canceled and built and processed from the Eligibility System on the selected date.',
    },
    {
      fieldName: 'Total Transactions',
      description: 'Total number of records processed on the selected date.',
    },
    {
      fieldName:
        'Total Auto-Cancels and Transactions Built from Eligibility System',
      description:
        'Total number of transactions auto-canceled and built and processed from the Eligibility System on the selected date.',
    },
    {
      section: 'Successful Transaction Counts',
      fieldName: '',
      description:
        'Successful Transaction Counts include transactions that processed successfully and updated the source eligibility system.  This includes transactions without errors and transactions with a severity 4 or 5 warning.',
    },
    {
      section: '',
      fieldName: 'Adds',
      description: '',
    },
    {
      section: '',
      fieldName: 'Subscriber Adds',
      description: 'Total number of successful subscriber add transactions',
    },
    {
      section: '',
      fieldName: 'Dependent Adds',
      description: 'Total number of successful dependent add transactions',
    },
    {
      section: '',
      fieldName: 'Total Adds',
      description: 'Total number of successful add transactions',
    },
    {
      section: '',
      fieldName: 'Terms',
      description: '',
    },
    {
      section: '',
      fieldName: 'Subscriber Terms Submitted',
      description:
        'Total number of successful subscriber terminations submitted on the file',
    },
    {
      section: '',
      fieldName: 'Dependent Terms Submitted',
      description:
        'Total number of successful dependent terminations submitted on the file',
    },
    {
      section: '',
      fieldName: 'Terms Submitted',
      description: 'Total number of successful terms submitted on the file',
    },
    {
      section: '',
      fieldName: 'Subscriber Auto-Cancels',
      description:
        'Total number of successful subscriber auto-cancel transactions',
    },
    {
      section: '',
      fieldName: 'Dependent Auto-Cancels',
      description:
        'Total number of successful dependent auto-cancel transactions',
    },
    {
      section: '',
      fieldName: 'Auto-Cancels',
      description: 'Total number of successful auto cancel transactions',
    },
    {
      section: '',
      fieldName: 'Total Terms',
      description: 'Total number of successful transactions terminated',
    },
    {
      section: '',
      fieldName: 'Changes',
      description: '',
    },
    {
      section: '',
      fieldName: 'Address',
      description: 'Total number of successful address change transactions',
    },
    {
      section: '',
      fieldName: 'Coverage',
      description: 'Total number of successful coverage change transactions',
    },
    {
      section: '',
      fieldName: 'Demographic',
      description: 'Total number of successful demographic change transactions',
    },
    {
      section: '',
      fieldName: 'Total Changes',
      description: 'Total number of successful change transactions',
    },
    {
      section: '',
      fieldName: 'No Changes',
      description: 'Total number of transactions that had no changes',
    },
    {
      section: '',
      fieldName: 'Total',
      description: 'Total number of successful transactions processed',
    },
    {
      section: 'GPS Status Counts',
      fieldName: '',
      description:
        'The Record Counts contain all transactions that were waiting for GPS status',
    },
    {
      section: '',
      fieldName: 'Pending GPS Status Update',
      description: 'The number of transactions that waiting for GPS status',
    },
    {
      section: 'Error Transaction Counts',
      fieldName: '',
      description:
        'Error Transaction Counts include transactions that had severity 1, 2, or 3 errors.  These transactions did not update the eligibility source system.',
    },
    {
      section: '',
      fieldName: 'Terms Submitted Requiring Enrollment Processor Resolution',
      description:
        'Total number of terminations submitted on the file requiring Enrollment Processor resolution.',
    },
    {
      section: '',
      fieldName: 'Auto-Cancels Requiring Enrollment Processor Resolution',
      description:
        'Total number of auto-cancel transactions requiring Enrollment Processor resolution.',
    },
    {
      section: '',
      fieldName: 'Terms Requiring Enrollment Processor Resolution',
      description:
        'Total number of terminated transactions requiring Enrollment Processor resolution.This includes terminations submitted on the file and auto-cancel transactions.',
    },
    {
      section: '',
      fieldName: 'Changes Requiring Enrollment Processor Resolution',
      description:
        'Total number of change transactions requiring Enrollment Processor resolution.',
    },
    {
      section: '',
      fieldName:
        'Rejected Transactions Requiring Enrollment Processor Resolution',
      description:
        'Total number of rejected transactions requiring Enrollment Processor resolution.',
    },
    {
      section: '',
      fieldName: 'Total Enrollment Processor Resolution Transactions',
      description:
        'Total number of transactions requiring Enrollment Processor resolution.',
    },
    {
      section: '',
      fieldName: 'Adds Requiring Customer Resolution',
      description:
        'Total number of add transactions requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Terms Submitted Requiring Customer Resolution',
      description:
        'Total number of terminations submitted on the file requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Total Enrollment Processor Resolution Transactions',
      description:
        'Total number of transactions requiring Enrollment Processor resolution.',
    },
    {
      section: '',
      fieldName: 'Adds Requiring Customer Resolution',
      description:
        'Total number of add transactions requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Terms Submitted Requiring Customer Resolution',
      description:
        'Total number of terminations submitted on the file requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Auto-Cancels Requiring Customer Resolution',
      description:
        'Total number of auto-cancel transactions requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Terms Requiring Customer Resolution',
      description:
        'Total number of terminated transactions requiring customer resolution.  This includes terminations submitted on the file and auto-cancel transactions.',
    },
    {
      section: '',
      fieldName: 'Changes Requiring Customer Resolution',
      description:
        'Total number of change transactions requiring customer resolution',
    },
    {
      section: '',
      fieldName: 'Rejected Transactions Requiring Customer Resolution',
      description:
        'Total number of rejected transactions requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Total Customer Resolution Transactions',
      description:
        'Total number of transactions requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Rejected Transactions Requiring Customer Resolution',
      description:
        'Total number of rejected transactions requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Adds Requiring Eligibility Analyst Resolution',
      description:
        'Total number of add transactions requiring eligibility analyst resolution.',
    },
    {
      section: '',
      fieldName: 'Terms Submitted Requiring Eligibility Analyst Resolution',
      description:
        'Total number of terminations submitted on the file requiring eligibility analyst resolution.',
    },
    {
      section: '',
      fieldName: 'Auto-Cancels Requiring Eligibility Analyst Resolution',
      description:
        'Total number of auto-cancel transactions requiring eligibility analyst resolution.',
    },
    {
      section: '',
      fieldName: 'Terms Requiring Eligibility Analyst Resolution',
      description:
        'Total number of terminated transactions requiring eligibility analyst resolution.  This includes terminations submitted on the file and auto-cancel transactions.',
    },
    {
      section: '',
      fieldName: 'Changes Requiring Eligibility Analyst Resolution',
      description:
        'Total number of change transactions requiring eligibility analyst resolution.',
    },
    {
      section: '',
      fieldName:
        'Rejected Transactions Requiring Eligibility Analyst Resolution',
      description:
        'Total number of rejected transactions requiring eligibility analyst resolution.',
    },
    {
      section: '',
      fieldName: 'Total Eligibility Analyst Resolution Transactions',
      description:
        'Total number of transactions requiring eligibility analyst resolution.',
    },
    {
      section: '',
      fieldName: 'Transactions Requiring Both Resolutions',
      description:
        'Total number of transactions requiring both eligibility analyst and customer resolution -- these transactions have at least one error requiring eligibility analyst and at least one error requiring customer resolution.',
    },
    {
      section: '',
      fieldName: 'Total Transactions with Errors',
      description: 'Total number of transactions with errors.',
    },
    {
      section: 'Error and Warning Counts',
      fieldName: '',
      description:
        'Error and Warning Counts include a count of all errors and warnings.  A single transaction can have more than one error or warning.',
    },
    {
      section: '',
      fieldName: 'Enrollment Processor Errors and Warnings',
      description:
        'Total number of Enrollment Processor errors and warnings generated',
    },
    {
      section: '',
      fieldName: 'Customer Errors and Warnings',
      description: 'Total number of customer errors and warnings generated',
    },
    {
      section: 'Eligibility Analyst Errors and Warnings',
      fieldName: '',
      description:
        'Total number of eligibility analyst error and warning pends generated',
    },
    {
      section: '',
      fieldName: 'Total Errors and Warnings',
      description:
        'Total number of errors and warnings that require customer or eligibility analyst resolution',
    },
    {
      section: 'Field Change Transaction Counts',
      fieldName: '',
      description: 'Count of all changes and attempted changes by field name.',
    },
    {
      section: '',
      fieldName: 'View Field Change Summary',
      description:
        'Displays summary of all changes and attempted changes by field name.',
    },
  ];
  const handleURLChange = (page) => {
    window.location.href = `/home/help/${page}`;
  };
  return (
    <>
      <p>
        After selecting the link to reports for a file run on the Electronic
        Eligibility Management System home page, the Processing Statistics
        screen is displayed for the selected date. The Processing Statistics
        page displays key statistics of a processed transaction. From this
        window you can also view the{' '}
        <Link onClick={() => handleURLChange('eligCorr')}>
          Eligibility Analyst Corrections Required
        </Link>
        page which contains transactions that the Eligibility Analyst is
        currently reviewing specific to the file processing date. Links are also
        available to{' '}
        <Link onClick={() => handleURLChange('addTran')}>Add Transactions</Link>
        ,{' '}
        <Link onClick={() => handleURLChange('chgTran')}>
          Change Transactions
        </Link>
        ,{' '}
        <Link onClick={() => handleURLChange('nochg')}>
          No Change Transactions
        </Link>
        ,{' '}
        <Link onClick={() => handleURLChange('TermAutoChg')}>
          Terms Submitted/Auto-Cancel Transactions
        </Link>
        ,
        <Link onClick={() => handleURLChange('eligCorr')}>
          Enrollment Processor Corrections Required
        </Link>
        ,{' '}
        <Link onClick={() => handleURLChange('subCorr')}>
          Customer Corrections Required
        </Link>
        ,{' '}
        <Link onClick={() => handleURLChange('errWarSum')}>
          Error and Warning Summary
        </Link>
        , and{' '}
        <Link onClick={() => handleURLChange('fldchgSum')}>
          Field Change Summary pages
        </Link>
        .
      </p>
      <br />
      <p>
        To print the information on this page, click on the Print button located
        in the upper right -hand corner of the page.
      </p>
      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column css={{ width: 160 }}>Section</Table.Column>
            <Table.Column css={{ width: 180 }}>Field</Table.Column>
            <Table.Column>Field Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {procStatJsonArr.map((item) => (
          <Table.TableBody>
            {!(item.fieldName === 'Processing Status') && (
              <Table.Row>
                <Table.Cell>{item.section}</Table.Cell>
                <Table.Cell>{item.fieldName}</Table.Cell>
                <Table.Cell>{item.description}</Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Processing Status' && (
              <Table.Row>
                <Table.Cell></Table.Cell>
                <Table.Cell>Processing Status</Table.Cell>

                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Status Code</Table.Column>
                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {procStatStatusJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.statusCode}</Table.Cell>
                          <Table.Cell>{item2.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.TableBody>
        ))}
      </Table.Container>

      <Table.Container title="Manual Static Table">
        {remContentJsonArr.map((item) => (
          <Table.TableBody>
            <Table.Row>
              <Table.Cell width={160}>{item.section}</Table.Cell>
              <Table.Cell width={180}>{item.fieldName}</Table.Cell>
              <Table.Cell>{item.description}</Table.Cell>
            </Table.Row>
          </Table.TableBody>
        ))}
      </Table.Container>
    </>
  );
};
